// @ts-nocheck
import React, { useEffect, useState, useMemo } from 'react';
import { useAuthAction } from '@ywfe/authmodules';
import { Login } from './auth.login';
import { ResetPassword } from './auth.resetPassword';
import { LoginWxScan } from './auth.loginWxScan';
import { YAuthProps } from './auth.interface';
import { FormStyle, LoginLogoStyle, FormBoxStyle, ChangeIconStyle, GlobalStyle } from './styles';

export const YAuth: React.FC<YAuthProps> = (props) => {
  const { actionCodeLogin } = useAuthAction();
  const [showWxLogin, setShowWxLogin] = useState(true);
  const [actionType, setActionType] = useState<string>('login');
  const [pageType, setPageType] = useState<string>('loginByWxScan');
  const switchType = (key: string) => {
    sessionStorage.setItem('login_type', key);
    setPageType(key);
    if (key === 'loginByPassword') {
      setActionType('login');
    }
  };

  const changeActionType = (type: string) => {
    setActionType(type);
  };

  useEffect(() => {
    // iframe打开遥望云，隐藏企业微信登录
    if (typeof window !== 'undefined' && window.self !== window.top) {
      setShowWxLogin(false);
    }
    actionCodeLogin();
  }, []);
  return (
    <FormStyle {...(props.style || {})}>
      <GlobalStyle />
      <FormBoxStyle>
        {actionType === 'login' && (
          <>
            {pageType === 'loginByPassword' && (
              <>
                <div className="title">账号登录</div>
                <span
                  onClick={() => {
                    switchType('loginByWxScan');
                  }}
                >
                  <ChangeIconStyle
                    icon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_code_normal@2x.png"
                    hoverIcon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_hover@2x.png"
                  />
                </span>
                <Login onChangeType={() => changeActionType('resetPassword')} />
              </>
            )}
            {pageType === 'loginByWxScan' && (
              <>
                {/* <div className="title">扫码登录</div> */}
                <span
                  onClick={() => {
                    switchType('loginByPassword');
                  }}
                >
                  <ChangeIconStyle
                    icon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_normal@2x.png"
                    hoverIcon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_code_hover@2x.png"
                  >
                    <span>切换登录</span>
                  </ChangeIconStyle>
                </span>
                <LoginWxScan id={props.id} />
              </>
            )}
            {/* <Tabs defaultActiveKey="loginByPassword" onChange={switchType}>
              <TabPane tab="账号密码" key="loginByPassword">
                <ChangeIconStyle
                  icon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_code_normal@2x.png"
                  hoverIcon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_hover@2x.png"
                ></ChangeIconStyle>
                <Login onChangeType={() => changeActionType('resetPassword')} />
              </TabPane>
              {showWxLogin && (
                <TabPane tab="企业微信扫码" key="loginByWxScan">
                  <ChangeIconStyle
                    icon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_normal@2x.png"
                    hoverIcon="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/icon_code_hover@2x.png"
                  >
                    <span>切换登录</span>
                  </ChangeIconStyle>
                  <LoginWxScan />
                </TabPane>
              )}
            </Tabs> */}
          </>
        )}
        {actionType === 'resetPassword' && (
          <ResetPassword
            onChangeType={() => {
              changeActionType('login');
            }}
          />
        )}
      </FormBoxStyle>
    </FormStyle>
  );
};
